
//////////////////////////////////////////////////////////////////////////////////////////////////////////////

<template>
  <div style="width:100%;height:100%;position:relative">
  <div class="login-panel-wrapper">
    <div class="login-panel">
      <div class='login-header'>
        <span class='login-app-title'>{{appSettings.appName}}</span>
      </div>
      <keep-alive>
        <router-view></router-view>
      </keep-alive>
    </div>
  </div>
  </div>
</template>

//////////////////////////////////////////////////////////////////////////////////////////////////////////////

<script>
import { mapGetters } from 'vuex'

export default {
  computed: {
    ...mapGetters([
      'appSettings'
    ])
  }
}
</script>

//////////////////////////////////////////////////////////////////////////////////////////////////////////////

<style>
#app .login-panel-wrapper {
  width: 100%;
  height: auto;
  min-height: 100%;
  padding-top: 50px;
  text-align: center;
  position:absolute;
  z-index:1;
  background-color: #6070dd;
  background: url('/static/welcome-background-vsezdes-2.jpg') no-repeat center;
  background-size: cover;
  background-position: center;
}
#app .login-panel {
  width: 75vw;
  padding: 20px;
  margin-bottom: 50px;
  display: inline-block;
  font-family: "Open Sans", sans-serif;
  font-weight: 300;
  background: rgba(255,255,255,1.0);
  border-radius: 20px;
}

@media screen and (min-width: 768px) {
  #app .login-panel-wrapper {
    padding-top: 100px;
  }
  #app .login-panel {
    width: 500px;
  }
}

/*****************************************************/

#app .login-header {
  margin-bottom: 20px;
  color: rgba(128,128,128,1.0);
  /*background: rgba(255,255,255,.0);*/
}

#app .login-text-title {
  display: block;
  /*font-family: "Lato Thin", sans-serif;*/
  font-family: 'Lobster', cursive;
  font-size: 60px;
  color: #fff;
  background: #000;
  text-align: left;
  margin-left: 100px;
  padding-left: 30px;
  padding-right: 40px;
  padding-top: 10px;
  padding-bottom: 10px;
}
#app .login-text{
  display: block;
  font-family: "Open Sans", sans-serif;
  font-weight: 300;
  line-height: 1.2;
  font-size: 15px;
  text-align: left;
  padding-bottom: 10px;
}

#app .login-app-title {
  display: block;
  /* font-family: "Lato Light", sans-serif; */
  font-family: 'Lobster', cursive;
  font-size: 50px;
  color: #788099;
  text-align: center;
  padding-bottom: 0px;
}
#app .login-app-ver {
  display: block;
  font-family: "Open Sans", sans-serif;
  font-weight: 300;
  font-size: 12px;
  color: #999;
  text-align: center;
  padding: 0 0px 30px 0;
}

/*****************************************************/

#app .login-form-title{
  display: block;
  text-align: center;
  font-family: "Open Sans", sans-serif;
  font-weight: 300;
  font-size: 20px;
  margin-bottom: 10px;
}
#app .login-form-text{
  display: block;
  text-align: left;
  font-family: "Open Sans", sans-serif;
  font-weight: 300;
  font-size: 14px;
  margin-bottom: 20px;
}
#app .login-form-button{
  margin-top: 10px;
  /*background: #6770a6;*/
  border-radius: 15px;
  background: #6070dd;
  font-size: 20px;
}
#app .login-form-links-group{
  margin-top: 15px;
}
#app .login-form-link{
  font-size: 16px;
}

</style>

//////////////////////////////////////////////////////////////////////////////////////////////////////////////



// WEBPACK FOOTER //
// Welcome.vue?b2891196